var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useAperzaUserContext } from '../header/AperzaUserContext';
import { useResponsiveContext } from './ResponsiveContext';
import AppService from './AppService';
import AppConfig from './AppConfig';
import { addUtmParam } from './addUtmParam';
export default function ServiceLogo() {
    var serviceType = useAperzaUserContext().serviceType;
    var isMobile = useResponsiveContext().isMobile;
    var imageFile = 'logo.svg';
    var url = AppService.wwwServerHost();
    var alt = 'ものづくり産業向けポータルサイト Apérza（アペルザ）';
    var width = 128;
    var height = 43; // (fixed)
    var mWidth = 90; // Mobile width
    var mHeight = 30; // Mobile height (fixed)
    switch (serviceType) {
        case AppConfig.APERZA_TV:
            imageFile = 'logo_tv.svg';
            url = AppService.tvServerHost();
            alt = 'ものづくり産業向けカタログサイト Apérza TV（アペルザTV）';
            width = 174;
            mWidth = 122;
            break;
        case AppConfig.APERZA_NEWS:
            imageFile = 'logo_news.svg';
            url = AppService.newsServerHost();
            alt = 'ものづくり産業向けカタログサイト Apérza News（アペルザニュース）';
            width = 215;
            mWidth = 150;
            break;
        case AppConfig.APERZA_CATALOG:
            imageFile = 'logo_catalog.svg';
            url = "".concat(AppService.wwwServerHost(), "/catalog/");
            alt = 'ものづくり産業向けカタログサイト Apérza Catalog（アペルザカタログ）';
            width = 251;
            mWidth = 175;
            break;
        case AppConfig.APERZA_EC:
            imageFile = 'logo_ec.svg';
            url = AppService.ecServerHost();
            alt = 'ものづくり産業向けカタログサイト Apérza EC（アペルザEC）';
            width = 174;
            mWidth = 121;
            break;
        case AppConfig.APERZA_DX:
            imageFile = 'logo_dx.svg';
            url = AppService.cloudServerHost();
            width = 176;
            mWidth = 123;
            break;
        default:
            break;
    }
    return (_jsx("a", __assign({ href: addUtmParam(url, 'header', serviceType) }, { children: _jsx("img", { alt: alt, src: "".concat(AppService.staticServerHost(), "/common/images/aperza2022/red/").concat(imageFile), width: isMobile ? mWidth : width, height: isMobile ? mHeight : height }) })));
}
